import { useState } from 'react';
import usePostIamResetPassword from '../api/usePostIamResetPassword';
import useUpdateIam from '../api/useUpdateIam';
import OrganizationSettingsTabs from '../components/SettingsTabs';
import StaffForm from './StaffForm';
import useFetchIam from '@/features/agent/api/useFetchIam';
import usePostIamAttachAvatar from '../api/usePostIamAttachAvatar';
import { showSuccessToast, showErrorToast } from '../../job_change_processes/lib/toast';

export default function AccountSettings() {
  const { data: iam, isLoading } = useFetchIam();
  const { mutateAsync: updateIamMain } = useUpdateIam();
  const { mutateAsync: updateIamPassword } = usePostIamResetPassword();
  const { mutateAsync: updateIamAvatar } = usePostIamAttachAvatar();
  const [resetPasswordFields, setResetPasswordFields] = useState(false);

  if (isLoading) {
    return <div>読み込み中...</div>;
  }

  if (!iam) {
    return <div>ユーザー情報が取得できませんでした。</div>;
  }

  const handleUpdate = async (
    name: string,
    email: string,
    is_admin: boolean,
    avatar?: File | null
  ) => {
    if (avatar) {
      try {
        await updateIamAvatar({ avatar });
        await updateIamMain({ name, email, is_admin });
        showSuccessToast('登録情報を保存しました。');
      } catch (error) {
        showErrorToast('登録情報を保存できませんでした。');
      }
    } else {
      try {
        await updateIamMain({ name, email, is_admin });
        showSuccessToast('登録情報を保存しました。');
      } catch (error) {
        showErrorToast('登録情報を保存できませんでした。');
      }
    }
  };

  const handleUpdateIamPassword = async (password: string, password_confirmation: string) => {
    try {
      await updateIamPassword({ password, password_confirmation });
      setResetPasswordFields(true);
      showSuccessToast('パスワードを変更しました。');
    } catch (error) {
      showErrorToast('パスワードを変更できませんでした。');
    }
  };

  return (
    <>
      <OrganizationSettingsTabs />
      <div className="mt-4">
        <StaffForm
          currentUser={iam?.current_user}
          updateInfo={handleUpdate}
          updatePassword={handleUpdateIamPassword}
          resetPasswordFields={resetPasswordFields}
        />
      </div>
    </>
  );
}
